import { useState } from 'react'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import Select from 'components/Inputs/Select'
import DateInput from 'components/Inputs/DateInput'
import MainButton from 'components/Buttons/MainButton'
import { FaDownload } from 'react-icons/fa'

import {
  Container,
  Form,
  FormField,
  Input,
  Label,
  SubTitle
} from './styles'

export default function Report ({
  name,
  filters = [],
  onDownload,
  downloading = false
}) {
  const [showFilters, setShowFilters] = useState (false)
  const [filterValues, setFilterValues] = useState (() => {
    const initial = {}

    filters.forEach (f => {
      if (f.type === 'period') {
        initial[f.name] = f.options
      } else if (f.type === 'select') {
        initial[f.name] = null
      }
    })
    return initial
  })

  const handleFilterChange = (name, value) => {
    setFilterValues (prev => ({ ...prev, [name]: value }))
  }

  const handleFilterRemove = (name, value) => {
    setFilterValues (prev => ({
      ...prev, [name]: prev[name].filter (v => v.value !== value.value)
    }))
  }

  const toggleFilters = () => setShowFilters (!showFilters)

  const handleDownload = () => {
    onDownload (name, filterValues)
    setShowFilters (false)
  }

  return (
    <Container>
      <SubTitle onClick={toggleFilters}>
        {name}
      </SubTitle>
      {/* Fecha também com o clique fora: os filtros escolhidos continuam aqui ao reabrir */}
      <Dialog open={showFilters} onOpenChange={open => { if (!open) toggleFilters() }}>
        <DialogContent size='sm' aria-describedby={undefined}>
          <DialogHeader>
            <DialogTitle>Confirmar geração de relatório</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <Form>
              <FormField>
                <Label>Nome do relatório:</Label>
                <Input
                  type='text'
                  value={name}
                  disabled={true}
                  style={{ textAlign: 'center', fontWeight: 'bold' }}
                />
              </FormField>
              {filters.map (filter => {
                if (filter.type === 'period') {
                  return (
                    <FormField key={filter.name}>
                      <Label>{filter.label}:</Label>
                      <DateInput
                        value={filterValues[filter.name]}
                        selectRange={true}
                        onChange={value => handleFilterChange (filter.name, value)}
                        label={filter.label}
                        style={{width: '100%'}}
                      />
                    </FormField>
                  )
                }
                if (filter.type === 'select') {
                  return (
                    <FormField key={filter.name}>
                      <Select
                        name={filter.name}
                        placeholder={filter.label}
                        value={filterValues[filter.name]}
                        options={filter.options}
                        onChange={(_, option) => handleFilterChange (filter.name, option)}
                      />
                    </FormField>
                  )
                }
                if (filter.type === 'multi_select') {
                  return (
                    <FormField key={filter.name}>
                      <Select
                        name={filter.name}
                        placeholder={filter.label}
                        value={filterValues[filter.name] || []}
                        options={filter.options}
                        isMulti={true}
                        isClearable={true}
                        onRemoveOption={value => handleFilterRemove (filter.name, value)}
                        onChange={(_, option) => handleFilterChange (filter.name, option)}
                      />
                    </FormField>
                  )
                }
                return null
              })}
            </Form>
          </DialogBody>
          <DialogFooter>
            <MainButton
              label='Baixar relatório'
              leftIcon={<FaDownload size={14} color='#000000'/>}
              onClick={handleDownload}
              disabled={downloading}
              loading={downloading}
              width={180}
            />
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Container>
  )
}
